import {
  Input,
  InputProps,
  Label,
  makeStyles,
  useId,
} from "@fluentui/react-components";
import LabelWithInfoIcon from "./LabelWithInfoIcon";

interface IAppDateSelect {
  label: string;
  formHandler: any;
  currentDate?: string;
  infoTooltip?: string;
}

const useStyles = makeStyles({
  input: {
    width: "150px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
  },
});

export default function AppDateSelect(props: IAppDateSelect & InputProps) {
  const styles = useStyles();
  const { label, formHandler, infoTooltip, currentDate, ...rest } = props;
  const inputId = useId("date-input");
  return (
    <div className={styles.container}>
      <Label htmlFor={inputId}>
        {infoTooltip ? <LabelWithInfoIcon label={label} info={infoTooltip} /> : label}
      </Label>
      <Input
        type="date"
        min={currentDate}
        className={styles.input}
        {...formHandler}
        {...rest}
      />
    </div>
  );
}
